import React from "react";
import "../App.css";
import { Text } from "@fluentui/react-northstar";
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * The 'Config' component is used to display your group tabs
 * user configuration options.  Here you will allow the user to
 * make their choices and once they are done you will need to validate
 * their choices and communicate that to Teams to enable the save button.
 */
class InCallSidePanelConfig extends React.Component {
    state = {
        isMeeting: false,
    }

    async componentDidMount() {
        microsoftTeams.app.notifySuccess();

        this.checkForMeeting();

        /**
         * When the user clicks "Save", save the url for your configured tab.
         * This allows for the addition of query string parameters based on
         * the settings selected by the user.
         */
        microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
            if (this.state.isMeeting) {
                saveEvent.notifyFailure("Meetings are not supported");
            } else {
                const baseUrl = `https://${window.location.hostname}:${window.location.port}`;
                console.log("BaseUrl in registerOnSaveHandler:" + baseUrl)
                microsoftTeams.pages.config.setConfig({
                    suggestedDisplayName: "CyberGate",
                    entityId: "CyberGate",
                    contentUrl: baseUrl + "/index.html#/incallsidepanel",
                    websiteUrl: baseUrl + "/index.html#/incallsidepanel",
                });
                saveEvent.notifySuccess();
            }
        });
    }
    
    checkForMeeting = (): void => {
        microsoftTeams.app.getContext().then((context) => {
            console.log(`InCallSidePanelConfig context ${JSON.stringify(context)}`);

            if (context && context.chat)
            {
                const isMeeting = context.chat.id.includes('meeting');

                console.log(`InCallSidePanelConfig isMeeting ${isMeeting}`);

                this.setState({
                    isMeeting: isMeeting
                });

                /**
                 * After verifying that the settings for your tab are correctly
                 * filled in by the user you need to set the state of the dialog
                 * to be valid.  This will enable the save button in the configuration
                 * dialog.
                 */
                microsoftTeams.pages.config.setValidityState(!isMeeting);
            }
        });
    }

    render() {

        if (this.state.isMeeting) {
            return (
                <>
                <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div>
                        <Text align="center" content="Meetings are not supported." size="larger" />
                        <br/>
                        <Text align="center" content="This app is useful for 1:1 CyberGate calls only." size="medium" />
                        <Text align="center" content="Within these calls the app provides an easy way for opening the door." size="medium" />
                    </div>
                </div>
                </>
            );            
        }

        return (
            <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Text align="center" content="There are no settings required for this app. Please press save to continue." size="larger" />
            </div>
        );
    }
}

export default InCallSidePanelConfig;
